import { FormInput } from 'src/@types';
import { getDefaultValue } from 'src/components/shared/form-elements';
import { CalculatorsBuyerCostsStep1FormFields } from '../types';
import { IntlShape } from 'react-intl/src/types';

export const useCalculatorBuyerCostsStep1FormFields = (intl: IntlShape) => {
  const calculatorBuyerCostsStep1FormFields: Record<
    keyof CalculatorsBuyerCostsStep1FormFields,
    FormInput
  > = {
    housePrice: {
      fieldName: 'housePrice',
      label: intl.formatMessage({
        id: 'step1.housePrice',
        defaultMessage: 'Wat is de koopsom van de woning die je op het oog hebt?'
      }),
      type: 'currency',
      required: true,
      removeDecimals: true,
      placeHolder: '€ 200.000',
      tooltip: intl.formatMessage({
        id: 'step1.housePrice.tooltip',
        defaultMessage:
          'Als de definitieve koopsom nog niet bekend is, kun je hier ook de vraagprijs invullen.'
      }),
      defaultValue: getDefaultValue('200000')
    },
    isNewConstruction: {
      fieldName: 'isNewConstruction',
      label: intl.formatMessage({
        id: 'step1.isNewConstruction',
        defaultMessage: 'Is deze woning een nieuwbouwwoning?'
      }),
      type: 'radio',
      options: [
        { label: 'Ja', value: 'true' },
        { label: 'Nee', value: 'false' }
      ],
      defaultValue: getDefaultValue('false', true)
    },
    withPartner: {
      fieldName: 'withPartner',
      label: intl.formatMessage({
        id: 'step1.withPartner',
        defaultMessage: 'Koop je de woning alleen of samen met je partner?'
      }),
      type: 'radio',
      options: [
        { label: 'Alleen', value: 'false' },
        { label: 'Samen', value: 'true' }
      ],
      defaultValue: getDefaultValue('false', true)
    }
  };
  return calculatorBuyerCostsStep1FormFields;
};
